import { createSlice } from "@reduxjs/toolkit";

const b2bCoupons = createSlice({
  name: "b2bCoupons",
  initialState: {
    coupons: [],
    coupon: "",
    economicGroupCompanys: [],
  },
  reducers: {
    setCoupons(state, { payload }) {
      state.coupons = payload;
    },
    setEconomicGroupCompanys(state, { payload }) {
      state.economicGroupCompanys = payload;
    },
    setCoupon(state, { payload }) {
      state.coupon = payload;
    },
  },
});

export const { setCoupons, setCoupon, setEconomicGroupCompanys } = b2bCoupons.actions;

export default b2bCoupons.reducer;
